import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import type { TellescopeFieldResponse } from "../types";
import { getLatestBridgeEligibilityAnswer } from "./get-prior-response-value";

/**
 * Whether an Appointment Booking field configured to filter by an eligibility check has no
 * providers left to book with.
 *
 * Such a field can never be answered, so it must not gate navigation or submission — it renders an
 * explanation in place of the booking page and is treated as satisfied.
 */
export const isBookingBlockedByEligibility = (
  field: Pick<TellescopeModelFromName<"form_fields">, "type" | "options">,
  responses: TellescopeFieldResponse[]
): boolean => {
  if (field.type !== "Appointment Booking") return false;
  if (!field.options?.useBridgeEligibilityResult) return false;

  return !getLatestBridgeEligibilityAnswer(responses)?.userIds?.length;
};
